import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import UserForm from "./UserForm";
import { useCreateUserMutation } from "../../redux/api/usersApi";
import { useGetRolesQuery } from "../../redux/api/rolesApi";

const AddUserPage = () => {
  const navigate = useNavigate();
  
  // Fetch roles for the form
  const { 
    data: roles = [], 
    isLoading: rolesLoading, 
    error: rolesError 
  } = useGetRolesQuery();
  
  // Create mutation
  const [createUser, { isLoading: isCreating, error: createError }] = useCreateUserMutation();

  const handleAddUser = async (formData) => {
    try {
      await createUser(formData).unwrap();
      toast.success('User created successfully');
      navigate("/admin/users");
    } catch (error) {
      toast.error(error?.data?.message || error?.error || 'Failed to create user');
    }
  };

  return (
    <div>
      <h1 className="mb-4">Add User</h1>
      {rolesError && (
        <div className="alert alert-danger">
          {rolesError?.data?.message || rolesError?.error || 'Failed to load roles'}
        </div>
      )}
      {createError && (
        <div className="alert alert-danger">
          {createError?.data?.message || createError?.error || 'Failed to create user'}
        </div>
      )}
      {rolesLoading ? (
        <div>Loading roles...</div>
      ) : (
        <UserForm 
          roles={roles} 
          onSubmit={handleAddUser} 
          loading={isCreating}
        />
      )}
    </div>
  );
};

export default AddUserPage;
